import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

export type TlsConsentStringEnum = ValueStringEnum;

//---- Automatically generated, don't update this part ----

type ValueStringEnum = "agreed" | "disagreed" | "unknown";

/**
 * This JE indicates whether or not the patient consent to be under tls. This JE do not indicates if the patient is under TLS or not.
 */
export default class TlsConsentJournalEvent extends JournalEvent {
  static override type = "tls-consent-journal-event";

  @attr("string") declare value: ValueStringEnum;

  static override validations(intl: IntlService) {
    return {
      value: [
        validatePresence({
          presence: true,
          description: intl.t("validations.tls-consent-journal-event.value")
        }),
        validateInclusion({
          list: ["agreed", "disagreed", "unknown"],
          description: intl.t("validations.tls-consent-journal-event.value")
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.tls-consent-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "tlsConsentJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "tls-consent-journal-event": TlsConsentJournalEvent;
  }
}
